module.exports = __webpack_public_path__ + "static/img/MM.020e0ca7.png";